document.brklz = document.brklz || {};

var controller = document.brklz;

controller.collectionHandle = function () {
    if (document.brklz.collection_handle) { return document.brklz.collection_handle; }
    if (document.querySelector('.collection-handle-hidden')) {
        document.brklz.collection_handle = document.querySelector('.collection-handle-hidden').textContent.trim();
       return document.brklz.collection_handle;
    }
    return null;
};

document.brklz.onClickOpenFilters = function () {
    document.brklz.filter_box = document.querySelector('.filter-box');
    document.brklz.filter_box_screen = document.querySelector('.close-filter-box-screen');
    if (document.brklz.filter_box.className.indexOf('displayed') < 0) {
        document.brklz.filter_box.className += ' displayed';
        document.brklz.filter_box_screen.className += ' displayed';
    }
};

document.brklz.onClickCloseFilters = function () {
    if (document.brklz.filter_box.className.indexOf('displayed') > 0) {
        document.brklz.filter_box.className = document.brklz.filter_box.className.split('displayed')[0];
        document.brklz.filter_box_screen.className = document.brklz.filter_box_screen.className.split('displayed')[0];
    }
};

document.brklz.buildCurrentFiltersArray = function () {
    var filter_array = [];
    var checkboxes = document.getElementsByClassName('filter-checkbox');
    var letters = document.getElementsByClassName('letter-filter');
    for (i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) { filter_array.push(checkboxes[i].getAttribute('tag')); }
    }
    var letters = document.getElementsByClassName('letter-filter');
    for (i = 0; i < letters.length; i++) {
        if (letters[i].className.indexOf('selected') > 0) { filter_array.push(letters[i].getAttribute('tag')); }
    }
    return filter_array;
};

document.brklz.onClickApplyFilters = function (letter_filter) {
    var checkboxes = document.getElementsByClassName('filter-checkbox');
    var letters = document.getElementsByClassName('letter-filter');
    var i;
    var filter_array = [];
    var pathname = window.location.pathname.split('/');
    var new_url;
    if (pathname[pathname.length - 1] !== controller.collectionHandle()) {
        pathname.pop()
        new_url = pathname.join('/');
    } else {
        new_url = window.location.pathname;
    }
    for (i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) { filter_array.push(checkboxes[i].getAttribute('tag')); }
    }
    for (i = 0; i < letters.length; i++) {
        if (letters[i].className.indexOf('selected') > 0) { filter_array.push(letters[i].getAttribute('tag')); }
    }
    if (letter_filter) {
        filter_array = document.brklz.removeLetterFiltersFromArray(filter_array);
        filter_array.push(letter_filter);
    }
    if (filter_array.length === 0) {
        document.brklz.onClickClearFilters();
        return;        
    } else {
        if (new_url.slice(-1) !== '/') {
            new_url += '/';
        }
        new_url += filter_array.join('+');
        window.location.href = [location.protocol, '//', location.host, new_url].join('')
        // window.location.pathname = new_url;
    }
};

document.brklz.onClickClearFilters = function () {
    var checkboxes = document.getElementsByClassName('filter-checkbox');
    var i;
    var pathname = window.location.pathname.split('/');
    if (pathname[pathname.length - 1] === controller.collectionHandle()) {
        document.brklz.onClickCloseFilters();
        return;
    }
    var new_url = pathname;
    new_url.splice(-1, 1);
    window.location.pathname = new_url.join('/');
    return;
};

document.brklz.validateOnlyOneCheckboxPerGroup = function (elem) {
    var box = elem;
    var group_name, group, i;
    if (box.checked) {
        group_name = box.getAttribute('name'); 
        group = document.querySelectorAll('[name="' + group_name + '"]')
        for (i = 0; i < group.length; i++) {
            group[i].checked = false;
        }
        box.checked = true;
    }
};

document.brklz.removeLetterFiltersFromArray = function (filter_array) {
    var i;
    for (i = 0; i < filter_array.length; i++) {
        if (filter_array[i].indexOf('letter_') >= 0) {
            filter_array.splice(i, 1);
        }
    }
    return filter_array;
};

document.brklz.onClickClearLettersFilter = function () {
    var filter_array = document.brklz.buildCurrentFiltersArray();
    var pathname = window.location.pathname.split('/');
    var new_url;
    if (pathname[pathname.length - 1] !== controller.collectionHandle()) {
        pathname.pop()
        new_url = pathname.join('/');
    } else {
        new_url = window.location.pathname;
    }
    filter_array = document.brklz.removeLetterFiltersFromArray(filter_array);
    if (window.location.pathname.slice(-1) !== '/') {
        new_url += '/';
    }
    new_url += filter_array.join('+');
    console.log(new_url);
    window.location.pathname = new_url;
};

document.brklz.lettersFilterInit = function () {
    var letters = document.getElementsByClassName('letter-filter');
    var current_letter;
    for (i = 0; i < letters.length; i++) {
        if (letters[i].className.indexOf('selected') > 0) { current_letter = letters[i].getAttribute('tag') }
    }
    if (current_letter) {
        $('.letter-filters-container').animate({
            scrollLeft: $("#" + current_letter).position().left - ($('.letter-filters-container').width() / 2) + 15
        }, 1000);
    }
};
document.brklz.lettersFilterInit();